import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import store from './store';
import MyApp from './containers/MyApp';

import './index.css';

const rootElement = document.getElementById('root')
render(
  <Provider store={store}>
  	<MyApp />
  </Provider>,
  rootElement
);



// WEBPACK FOOTER //
// ./src/index.js